import { gql } from "@apollo/client";

const CLUBS_BY_SPORTS_ID = gql`
  query clubsBySportIds($sportIds: [Int!]!, $filter: ListClubInput) {
    clubsBySportIds(sportIds: $sportIds, filter: $filter) {
      club {
        id
        country
        clubName
        logo
        city
        status
        isAdminVerificationRequired
      }
      total
    }
  }
`;

export default CLUBS_BY_SPORTS_ID;
